import { createSelector } from "@reduxjs/toolkit";
import { find } from "lodash";

export const selectOpportunities = (state) => state?.opportunity?.opportunities;

export const selectOpportunitiesPageNumber = (state) =>
  state?.opportunity?.opportunities?.pageNumber;

export const selectCurrentFilter = (state) =>
  state?.opportunity?.opportunities?.currentFilter;

export const selectSavedSearches = (state) =>
  state?.opportunity?.opportunities?.savedSearches;

export const selectSelectedSearchId = (state) =>
  state?.opportunity?.opportunities?.selectedSearchId;

export const selectSavedSearchesByType = createSelector(
  [selectSavedSearches, (_, type) => type],
  (searches, type) => searches.filter((s) => s.type === type)
);

export const selectSelectedSearch = createSelector(
  [selectSavedSearches, selectSelectedSearchId],
  (searches, searchId) => {
    return find(searches, ["id", searchId]);
  }
);

export const selectIsLoading = (state) =>
  state?.opportunity?.opportunities?.isLoading;

export const selectIsMounted = (state) =>
  Boolean(state?.opportunity?.opportunities?.isInitialized);

export const selectTotalResults = (state) =>
  state?.opportunity?.opportunities?.totalResults || 0;

export const selectCurrentResults = (state) =>
  state?.opportunity?.opportunities?.currentResults || 0;

export const selectOpportunitiesSorting = (state) =>
  state?.opportunity?.opportunities?.sorting;

export const selectSelectedRowIndex = (state) =>
  state?.opportunity?.opportunities?.selectedRowIndex || -1;

export const selectShowEditModal = (state) =>
  state?.opportunity?.opportunities?.showEditModal;

export const selectEditModalFocusField = (state) =>
  state?.opportunity?.opportunities?.editModalFocusField;

export const selectAppliedFilter = (state) =>
  state?.opportunity?.opportunities?.appliedFilter;

export const selectAdditionalFilters = (state) =>
  state?.opportunity?.opportunities?.additionalFilters;

export const selectIsCustomLastUpdated = (state) =>
  state?.opportunity?.opportunities?.isCustomLastUpdated;

export const selectLastUpdatedValue = (state) =>
  state?.opportunity?.opportunities?.lastUpdatedValue;

export const selectTabConfiguration = (state) =>
  state?.opportunity?.opportunities?.tabConfiguration;

export const selectPreserveFiltersForType = (state) =>
  state?.opportunity?.opportunities?.preserveFiltersForType;
